import { render } from "./OngoingVisit.vue?vue&type=template&id=9f35cc1a&scoped=true"
import script from "./OngoingVisit.vue?vue&type=script&lang=js"
export * from "./OngoingVisit.vue?vue&type=script&lang=js"

import "./OngoingVisit.vue?vue&type=style&index=0&id=9f35cc1a&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f35cc1a"]])

export default __exports__